/**
 * Created by charnjeetelectrovese@gmail.com on 9/28/2017.
 */
import Constants from '../config/constants';
export function roundUnit(unit) {
    if(unit >= 1000) {
        return `${unit / 1000} Kg`;
    } else {
        return `${unit} Gm`;
    }
}

export const asyncForEach = async (array, callback) => {
    for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
    }
};

export const updateTitle = (title) => {
    document.title = Constants.APP_NAME + ' - ' + title;
}

export const getObjData = (value, txt = 'N/A') => {
    return value ? value : txt;
}

export const getSumValue = (...numbers) => {
    return numbers ? numbers.reduce((sum, value) => {
        if (value) {
            return sum + parseFloat(value);
        } return sum;
    }, 0) : 0;
};

export const isIosSafari = () => {
    const ua = window.navigator.userAgent;
    const iOS = ua.match(/iPad/i) || ua.match(/iPhone/i);
    const webkit = ua.match(/WebKit/i);
    const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

    return iOSSafari;
}

/**
 * Generates a unique device ID for the browser and stores it in localStorage
 * This ID remains constant for the browser even after page refresh
 * @returns {string} The unique device ID
 */
export const getBrowserDeviceId = () => {
  // Check if we already have a device ID in localStorage
  const storedDeviceId = localStorage.getItem('browser_device_id');
  if (storedDeviceId) {
    return storedDeviceId;
  }
  
  // Only proceed if we're in a browser environment
  if (typeof window === 'undefined' || typeof window.navigator === 'undefined' || typeof window.screen === 'undefined') {
    return 'unknown-device';
  }
  
  // Generate components for a unique ID based on browser properties
  const components = [
    window.navigator.userAgent,
    window.navigator.language,
    window.screen.colorDepth,
    window.screen.width + 'x' + window.screen.height,
    new Date().getTimezoneOffset(),
    window.navigator.platform
  ];
  
  // Generate hash from components
  let deviceId = '';
  const combinedString = components.join('###');
  
  // Simple hash function
  for (let i = 0; i < combinedString.length; i++) {
    const char = combinedString.charCodeAt(i);
    deviceId = ((deviceId << 5) - deviceId) + char;
    deviceId = deviceId & deviceId; // Convert to 32bit integer
  }
  
  // Convert to string and make it positive
  deviceId = Math.abs(deviceId).toString(36) + Date.now().toString(36);
  
  // Store in localStorage for future use
  localStorage.setItem('browser_device_id', deviceId);
  
  return deviceId;
};
